<template>
  <div class="template-group">
    <el-row :gutter="20" class="template-list" v-for="group in data" :key="group.name">
      <el-col :span="24">
        <h3>{{ group.name }}</h3>
      </el-col>
      <el-col v-if="group.options.length < 1" :span="24">
       <div class="none-data"> 暂无{{ group.name }} </div>
      </el-col>
      <el-col
        v-for="template in group.options"
        :key="template.id"
        style="padding-bottom: 10px;width: 270px;"
      >
        <el-card
            class="template-card"
            :class="{ 'card-selected': selectedTemplateId === template.id }"
            :body-style="{ padding: '11px 10px' }"
            :title="template.appName"
            @click.native="selectTemplate(template.id, template)"
        >
          <img class="template-logo" :src="template.logoUrl ? template.logoUrl : defaultAppLogoUrl" alt="封面图片">
          <div class="template-title">
            <span>{{ template.appName }}</span>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'TemplateAndExampleGroup',
  props: {
    data: {
      required: true,
      type: Array,
      default: () => []
    },
    defaultAppLogoUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedTemplateId: -1
    }
  },
  destroyed() {
    this.selectedTemplateId = -1
  },
  methods: {
    selectTemplate(templateId, template) {
      this.selectedTemplateId = templateId
      this.$emit('select-template', templateId, template)
    }
  }
}
</script>

<style lang="less" scoped>
.template-list {
  h3 {
    margin: 5px 0;
  }
}

.template-card {
  cursor: pointer;
}
.card-selected {
  transition: border 0.3s; /* 添加过渡效果 */
  border: 1px solid #4D78FF;
}

.template-logo {
  width: 100%;
  height: 151px;
  display: block;
  border-radius: 4px;
}
.template-title {
  margin-top: 12px;
  text-align: center;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}

.none-data {
  height: 24px;
  line-height: 24px;
  text-align: center;
  color: #b6b6b6;
}
</style>
